import { SafeResourceUrl } from '@angular/platform-browser';
import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { CommonTurnViewModel } from 'src/app/model/common/turn.view';

export interface CommonTurnState {
  result: CommonTurnViewModel[];
  turnsId: number[];
  totalTurns: number;
  patientQuery: string;
  doctorQuery: string;
  specialtyQuery: string;
  lazyLoad: VonPageResponseModel<CommonTurnViewModel>;
  formSaved: boolean;
  turn: CommonTurnViewModel;
  file: {
    recipeFile?: SafeResourceUrl;
    showRecipePdf: boolean;
  };
}

export const commonTurnIS: CommonTurnState = {
  result: [],
  turnsId: [],
  totalTurns: 0,
  patientQuery: '',
  doctorQuery: '',
  specialtyQuery: '',
  lazyLoad: {
    content: [],
    last: false,
    totalPages: 0,
    totalElements: 0,
    size: 0,
    numberOfElements: 0,
    number: 0,
  },
  turn: {},
  formSaved: false,
  file: {
    showRecipePdf: false,
  },
};
